import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Loader2 } from 'lucide-react';
import AccessRestrictedScreen from './AccessRestrictedScreen';

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <Loader2 className="h-8 w-8 animate-spin text-[#003366]" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Check if user has access
  let hasAccess = allowedRoles && allowedRoles.includes(user.role);
  
  // Special case: technicians who are also housekeepers can access housekeeper routes
  if (!hasAccess && user.role === 'technicien' && user.is_also_housekeeper && allowedRoles?.includes('housekeeper')) {
    hasAccess = true;
  }

  if (!hasAccess) {
    // Redirect to appropriate dashboard based on role
    if (user.role === 'admin') {
      return <Navigate to="/admin" replace />;
    } else if (user.role === 'technicien') {
      return <Navigate to="/tech" replace />;
    } else if (user.role === 'gouvernant') {
      return <Navigate to="/gouvernant" replace />;
    } else {
      return <Navigate to="/app" replace />;
    }
  }

  // FDM access restriction: show blocking screen instead of FDM content
  if (user.role === 'housekeeper' && user.access_restricted) {
    return <AccessRestrictedScreen />;
  }

  return children;
};

export default ProtectedRoute;
